// 国家排名 tab
import React from 'react'
import { numberThumbnail } from 'src/helper/tool'
import RankingItem from '../ranking-item'

import './index.less'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  onJumpToUser = (userId) => {
    this.props.onJumpToUser(userId)
  }

  getDecorateUrl = (index) => {
    let url = '/img/activity/national-star/'
    switch (index) {
      case 0:
        url = url + 'img_rank_avatar_user_top1@2x.png'
        break
      case 1:
        url = url + 'img_rank_avatar_user_top2@2x.png'
        break
      default:
        url = url + 'img_rank_avatar_user_top3@2x.png'
        break
    }
    return url
  }

  render() {
    const { rankingList, tabType, lang, language } = this.props
    return (
      rankingList && (
        <div className='tab-ranking-cont'>
          <div className='hd'>
            <h2>{lang.this_week_national_star}</h2>
          </div>
          <div className='bd'>
            {/* 背景图层 */}
            <div className="bd-bg">
              <div className="last-week-bg">
                <img src="/img/activity/national-star/img_rank_user_bg@2x.png" />
              </div>
              <div className="bd-bg-list">
                <div className="top">
                  <img src="/img/activity/national-star/img_box_bg_frame_top@2x.png" />
                </div>
                <div className="min"></div>
                <div className="bottom">
                  <img src="/img/activity/national-star/img_box_bg_frame_bot@2x.png" />
                </div>
              </div>
            </div>
            {/* 背景图层 end */}
            <div className="podium-wrap">
              {
                rankingList &&
                rankingList.slice(0, 3).map((item, index) => {
                  return (
                    <div
                      className={`level
                        ${index === 0 ? 'champion' : ''}
                        ${index === 1 ? 'second' : ''}
                        ${index === 2 ? 'third' : ''}`
                      }
                      key={item.uid}
                    >
                      <div className="level-cont">
                        <div
                          className="img-wrap"
                          onClick={() => this.onJumpToUser(item.uid)}
                        >
                          <div className="decorate">
                            <img src={this.getDecorateUrl(index)} />
                          </div>
                          <div className="flag">
                            <img src={item.avatarurl} />
                          </div>
                        </div>
                        <div className="level-item-info">
                          <p className='name'>
                            {item.nickname}
                          </p>
                          <p className='id'>
                            ID: {item.duid}
                          </p>
                          <div className="number-wrap">
                            <img src={item.giftIcon} alt="" />
                            {/* {numberThumbnail(item.score)} */}
                            {item.score}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className="ranking-wrap">
            {
              rankingList &&
              rankingList.slice(3).map((item, index) => {
                return (
                  <RankingItem
                    key={item.uid}
                    type={tabType}
                    item={item}
                    index={index}
                    language={language}
                    onJumpToUser={this.props.onJumpToUser}
                  />
                )
              })
            }
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/tab-ranking/index.js